import { useState, useEffect } from 'react';
import Select from 'react-select';
import { _single } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectIDFunctionalSingleton = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const lista = _single.getMyBossArea();
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.IDLn === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.IDLn,
                    label: `${found.JsonCode} - ${found.NameArea}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.IDLn,
        label: `${item.JsonCode} - ${item.NameArea}`,
        item: item
    }));

    return (
        <div>
            {label !== " " && (
                <label>{label || "Areas Asignadas"}</label>
            )}
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Area..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
